import { render, staticRenderFns } from "./myFirstDayGCR.vue?vue&type=template&id=3912d9ee&scoped=true"
import script from "./myFirstDayGCR.vue?vue&type=script&lang=js"
export * from "./myFirstDayGCR.vue?vue&type=script&lang=js"
import style0 from "./myFirstDayGCR.vue?vue&type=style&index=0&id=3912d9ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3912d9ee",
  null
  
)

export default component.exports